import { Skeleton } from '@mui/material';

import { trpc } from '@/config/trpc';

import CaseCard from '@/shared/components/2.0/CaseCard';
import KpcCard from '@/shared/components/2.0/layout/KpcCard';

const CASE_CARD_SKELETON_COUNT = 12;

type CaseTaskWidgetProps = {
  filters: {
    systemTaskType: string;
    teamTaskTypeId: string;
  };
};

const CaseTaskWidget: React.FC<CaseTaskWidgetProps> = ({ filters }) => {
  const query = trpc.case.repair.getRepairCasesByTaskType.useQuery({
    page: 1,
    pageSize: 50,
    systemTaskType: filters.systemTaskType,
    teamTaskTypeId: filters.teamTaskTypeId,
  });

  return (
    <KpcCard isCompact className="grid h-full grid-cols-3 gap-2">
      {query.isLoading
        ? Array.from({ length: CASE_CARD_SKELETON_COUNT }, (_, index) => (
            <Skeleton key={index} className="h-32 w-full rounded-xl shadow" variant="rectangular" />
          ))
        : query.data?.items.map((caseData) => <CaseCard key={caseData.id} caseData={caseData} />)}
    </KpcCard>
  );
};

export default CaseTaskWidget;
